import { ApiResponse, Market, MarketCreateRequest, MarketId, MarketROI, MarketUpdateRequest } from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getMarkets = async () => {
  const response = await api.get<ApiResponse<Market[]>>('/markets');

  return unwrapApiResponse(response.data);
};

export const postMarket = async (request: MarketCreateRequest) => {
  const response = await api.post<ApiResponse<Market>>('/markets', request);

  return unwrapApiResponse(response.data);
};

export const getMarket = async (marketId: MarketId) => {
  const response = await api.get<ApiResponse<Market>>(`/markets/${marketId}`);

  return unwrapApiResponse(response.data);
};

export const getMarketRoi = async (marketId: MarketId) => {
  const response = await api.get<ApiResponse<MarketROI>>(`/markets/${marketId}/roi`);

  return unwrapApiResponse(response.data);
};

export const patchMarket = async (request: MarketUpdateRequest) => {
  const response = await api.patch<ApiResponse<Market>>(`/markets/${request.id}`, request);

  return unwrapApiResponse(response.data);
};

export const deleteMarket = async (marketId: MarketId) => {
  const response = await api.delete<ApiResponse<Market>>(`/markets/${marketId}`);

  return unwrapApiResponse(response.data);
};
